export enum FormsQuestionType {
    SingleSelectOption = 0,
    MultiSelectOption = 1,
    SingleSelectOptionPlusFreeFormText = 2,
    MultiSelectOptionPlusFreeFormText = 3,
    FreeFormTextOnly = 4
}